export const CREATE_RESERVATION = 'CREATE_RESERVATION';
export const GET_ALLRESERVATIONS = 'GET_ALLRESERVATIONS';
export const DELETE_RESERVATION = 'DELETE_RESERVATION';
